import React from 'react';
import styles from './MoreLink.module.scss';

const MoreLink = ({ url, label, target = '_self' }) =>
  <a href={ url } className={ styles.MoreLink }
    target={ target }
  >{ label }</a>;

export default MoreLink;
